import { render, staticRenderFns } from "./ErrorsAlert.vue?vue&type=template&id=2dea29ab&scoped=true"
import script from "./ErrorsAlert.vue?vue&type=script&lang=js"
export * from "./ErrorsAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dea29ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Wampp-latest\\www\\REZOSYSTEMS\\dev-ski-rentals5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dea29ab')) {
      api.createRecord('2dea29ab', component.options)
    } else {
      api.reload('2dea29ab', component.options)
    }
    module.hot.accept("./ErrorsAlert.vue?vue&type=template&id=2dea29ab&scoped=true", function () {
      api.rerender('2dea29ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/partials/ErrorsAlert.vue"
export default component.exports